<template>
  <div class="solution-security">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionSDKProduction"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details items-detail">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="core-competence">
        <div class="core-competence-item">
          <el-tabs v-model="activeName" class="tab-img" @tab-click="setActiveItems">
            <el-tab-pane label="人像分割" name="1">
            </el-tab-pane>
            <el-tab-pane label="基础美颜" name="2">
            </el-tab-pane>
            <el-tab-pane label="人脸试妆" name="3">
            </el-tab-pane>
            <el-tab-pane label="图像滤镜" name="4">
            </el-tab-pane>
            <el-tab-pane label="人脸贴纸" name="5">
            </el-tab-pane>
          </el-tabs>
          <div class="picscor">
            <el-carousel :interval="4000" type="card" :autoplay="false" :initial-index="1" height="426px" indicator-position="none" ref="ll" arrow="always" @change="changeIndex" class="pic-scoll" v-model="activeName">
            <el-carousel-item :key="1" name="1">
              <div class="is-show">
                <img src="./img/production/sdk_pic1.1.jpg" alt="" class="show-img">
                <span class="tit">人像分割</span>
                <span class="conten">支持半身、全身处于复杂场景下的人像分割应用，支持移动双端（iOS/android）快速接入。适用于线上会议、短视频互动等场景。</span>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="2" name="2">
              <div class="is-show">
                <img src="./img/production/sdk_pic1.2.jpg" alt="" class="show-img">
                <span class="tit">基础美颜</span>
                <span class="conten">支持实时视频流中，人脸磨皮、美白、自然基础功能实现，支持移动双端（iOS/android）快速接入。适用于直播互动、线上教育等场景。</span>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" name="3">
              <div class="is-show">
                <img src="./img/production/sdk_pic1.3.jpg" alt="" class="show-img">
                <span class="tit">人脸试妆</span>
                <span class="conten">支持实时视频流中，整体妆容的替换，同时可进行纯色、腮红、眼影等单点妆容替换，适用于美妆产品推广、直播短视频场景。</span>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" name="4">
              <div class="is-show">
                <img src="./img/production/sdk_pic1.4.jpg" alt="" class="show-img">
                <span class="tit">图像滤镜</span>
                <span class="conten">提供数十种滤镜素材，满足不同场景的滤镜美化需求，支持移动双端（iOS/android）快速接入。可应用于美颜相机、趣味视频拍摄等场景。</span>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="5" name="5">
              <div class="is-show">
                <img src="./img/production/sdk_pic1.5.jpg" alt="" class="show-img">
                <span class="tit">人脸贴纸</span>
                <span class="conten">基于优图领先的人脸关键点技术，支持2D素材完美贴合，满足趣味互动、直播短视频等场景的贴纸定制化需求。可应用于互动营销推广、视频直播等场景。</span>
              </div>
            </el-carousel-item>
          </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="items-detail">
      <div class="auditing-img-intro">
        <div class="auditing-plat-item"
          :class="{'no-margin-right' : ((index + 5) % 6 == 0) , 'mar' : ((index + 2) % 6 == 0)}"
          v-for="(item, index) in introAuditing"
          :key="index"
          :style="{backgroundImage: 'url(' + item.imgUrl + ')',backgroundSize: '420px 262px'}">
          <div class="intro-title">{{item.title}}</div>
          <div class="intro-info">{{item.info}}</div>
        </div>
      </div>
    </div> -->
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionSDKProduction"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionSDKProduction"></application-scene>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';
const coreCompetence = [
  {
    title: '通用印刷体识别（安卓版）',
    content: '基于业界领先的深度学习技术，支持多场景、任意版面下整图文字中的中英文、字母、数字、常见字符的识别。识别速度Mi8手机骁龙845CPU平均1个字符约1ms，识别精准度达到90%。',
    imgUrl: require('./img/android/functionpic_tyyst.jpg')
  }, {
    title: '身份证识别（安卓版）',
    content: '优图安卓版身份证识别，支持二代身份证正反面所有字段的识别，包括姓名、性别、民族、出生日期、住址、公民身份证号、签发机关、有效期限，为用户提供最方便快捷的身份证信息录入体验。Mi8手机骁龙845CPU平均1个字符约4ms，其中身份证号码识别准确率达到86%以上，姓名识别准确率91%以上。',
    imgUrl: require('./img/android/functionpic_sfz.jpg')
  }, {
    title: '银行卡识别（安卓版）',
    content: '优图安卓版银行卡识别，自动识别主流银行卡的卡号、有效期、卡类型、银行信息、及卡名等，为用户提供最方便快捷的身份证信息录入体验。识别速度Mi8手机骁龙845CPU平均1个字符约6ms，有效期的准确率、召回率均达到85%以上。',
    imgUrl: require('./img/android/functionpic_card.jpg')
  }, {
    title: '购车发票识别（安卓版）',
    content: '购车发票识别字段包括：（发票号码、发票代码、身份证号、开票日期、车辆识别代号_车架号码、价税合计、价税合计小写），为用户提供最方便快捷的发票信息录入体验。识别速度Mi8手机骁龙845CPU平均1个字符约4ms，识别精准度达到98%。',
    imgUrl: require('./img/android/functionpic_gcfp.jpg')
  }, {
    title: '营业执照识别（安卓版）',
    content: '优图安卓版营业执照识别，快速识别营业执照中的注册号、公司名称、法定代表人、注册资本、地址、营业期限、经营范围、主体类型等字段，识别速度Mi8手机骁龙845CPU平均1个字符约4ms，关键字段识别准确率达到88%以上。',
    imgUrl: require('./img/android/functionpic_yyzz.jpg')
  }, {
    title: '增值税发票识别（安卓版）',
    content: '增值税发票识别字段包括：（发票代码、开票日期、发票号码、销售方名称、购买方名称、购买方识别号、销售方识别号、合计金额、小写金额、税额）；识别速度Mi8手机骁龙845CPU平均1个字符约4ms，识别精准度达到98%。',
    imgUrl: require('./img/android/functionpic_zzs.jpg')
  }
];
// const introAuditing = [
//   {
//     title: '人像分割',
//     info: '支持半身、全身处于复杂场景下的人像分割应用，支持移动双端（iOS/android）快速接入。适用于线上会议、短视频互动等场景。',
//     imgUrl: require('./img/production/sdk_pic1.1.jpg')
//   }, {
//     title: '基础美颜',
//     info: '支持实时视频流中，人脸磨皮、美白、自然基础功能实现，支持移动双端（iOS/android）快速接入。适用于直播互动、线上教育等场景。',
//     imgUrl: require('./img/production/sdk_pic1.2.jpg')
//   }, {
//     title: '人脸试妆',
//     info: '支持实时视频流中，整体妆容的替换，同时可进行纯色、腮红、眼影等单点妆容替换，适用于美妆产品推广、直播短视频场景。',
//     imgUrl: require('./img/production/sdk_pic1.3.jpg')
//   }, {
//     title: '图像滤镜',
//     info: '提供数十中滤镜素材，满足不同场景的滤镜美化需求，支持移动双端（iOS/android）快速接入。可应用于美颜相机、趣味视频拍摄等场景。',
//     imgUrl: require('./img/production/sdk_pic1.4.jpg')
//   }, {
//     title: '人脸贴纸',
//     info: '基于优图领先的人脸关键点技术，支持2D素材完美贴合，满足趣味互动、直播短视频等场景的贴纸定制化需求。可应用于互动营销推广、视频直播等场景。',
//     imgUrl: require('./img/production/sdk_pic1.5.jpg')
//   }
// ];

export default {
  name: 'solutionproduction',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      coreCompetence,
      AnchorsItems: ['产品功能', '产品特点', '应用场景'],
      secondNavFixed: false,
      indexActive: 0,
      activeName: '2'
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    },
    setActiveItems() {
      this.$refs.ll.setActiveItem(this.activeName);
    },
    changeIndex(index) {
      this.activeName = (index + 1).toString();
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less">
.solution-security {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 50;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    overflow: hidden;
  }
  .items-detail{
    padding-bottom: 0;
  }
  .core-competence{
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    font-size: 0;
    position: relative;
    z-index: 0;
    .picscor{
      width: 100%;
      background: whitesmoke;
      .pic-scoll{
        width: 1420px;
        margin: 0 auto 0px;
      .el-carousel__container{
        width: 1320px;
        margin: 40px auto 62px;
        .el-carousel__mask{
          display: none;
        }
        .el-carousel__arrow--left{
          display: block;
          width: 42px;
          height: 122px;
          left: 5px;
          background: url('./img/production/icon_left_normal.png');
        }
        .el-carousel__arrow--left:hover{
          display: block;
          width: 42px;
          height: 122px;
          left: 5px;
          background: url('./img/production/icon_left_hover.png');
        }
        .el-icon-arrow-left{
          display: none;
        }
        .el-carousel__arrow--right{
          display: block;
          width: 42px;
          height: 122px;
          right: -9px;
          background: url('./img/production/icon_right_normal.png');
        }
        .el-carousel__arrow--right:hover{
          display: block;
          width: 42px;
          height: 122px;
          right: -9px;
          background: url('./img/production/icon_right_hover.png');
        }
        .el-icon-arrow-right{
          display: none;
        }
      }
      .el-carousel__item{
        z-index: -5;
      }
      .is-in-stage{
        width: 420px;
        height: 426px;
        z-index: 0;
        left: 102px;
        background: white;
        display: block;
        background-color: #ffffff;
        box-shadow: 0px 2px 6px 0px  rgba(47, 99, 150, 0.1);
        border: solid 1px #dcebf5;
      }
      .is-active{
        width: 420px;
        height: 426px;
        background-color: #ffffff;
        box-shadow: 0px 4px 20px 0px  rgba(47, 99, 150, 0.2);
        border: solid 1px #dcebf5;
      }
    }
  }
    .is-show{
      width: 420px;
      height: 426px;
      z-index: 1;
      .show-img{
        width: 420px;
        height: 262px;
      }
      .tit{
        display: inline-block;
        width: 380px;
        height: 30px;
        font-family: PingFang SC;
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
        padding: 20px 20px 0;
      }
      .conten{
        float: left;
        width: 380px;
        height: 74px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 1px;
        color: #7f8285;
        padding: 11px 20px 0;
      }
    }
    .el-tabs__header{
      margin: 0 auto;
      font-size: 18px;
      .el-tabs__item{
        padding: 0;
        text-align: center;
        margin: 0 auto;
        width: 104px;
        height: 34px;
        font-family: PingFang SC;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 0px;
      }
      .is-active{
        width: 104px;
        text-align: center;
        border-bottom: 2px solid #409EFF;
      }
    }
    .el-tabs__nav{
      text-align: center;
      .el-tabs__active-bar{
        display: none;
      }
    }
    .el-tabs__nav-wrap{
      width: 520px;
      margin: 0 auto;
    }
  }
  // .auditing-img-intro{
  //   width: 1320px;
  //   height: 970px;
  //   margin: 50px auto 0;
  //   font-size: 0;
  //   .auditing-plat-item{
  //     position: relative;
  //     vertical-align: top;
  //     width: 420px;
  //     height: 426px;
  //     background: 420px 262px;
  //     border: #e6e6e6 1px solid;
  //     margin: 5px 0px;
  //     display: inline-block;
  //     background-repeat: no-repeat;
  //     background-position: center 0;
  //     color: #242526;
  //     &.mar{
  //       margin: 5px 30px 37px;
  //     }
  //     &.no-margin-right{
  //       margin: 5px 30px 37px;
  //     }
  //     .intro-title {
  //       display: inline-block;
  //       width: 380px;
  //       height: 30px;
  //       font-family: PingFang SC;
  //       font-size: 22px;
  //       font-weight: normal;
  //       font-stretch: normal;
  //       line-height: 30px;
  //       letter-spacing: 0px;
  //       color: #333333;
  //       padding: 282px 20px 0px;
  //     }
  //     .intro-info {
  //       float: left;
  //       width: 380px;
  //       height: 74px;
  //       font-family: PingFang SC;
  //       font-size: 16px;
  //       font-weight: normal;
  //       font-stretch: normal;
  //       line-height: 26px;
  //       letter-spacing: 1px;
  //       color: #7f8285;
  //       padding: 10px 20px 0;
  //     }
  //   }
  // }
  .solution-title{
    margin-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro-education{
    width: 1170px;
    margin: 0 auto;
    color: #212121;
    .content{
      font-size: 16px;
      line-height: 1.8;
      text-align: justify;
    }
    .img-title {
      margin-top: 58px;
      margin-bottom: 26px;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionSDKProduction.vue